// #region Imports
import { defineComponent } from "vue";
// #endregion
// #region Core
export default defineComponent({
    name: 'g-intranet-layout__footer',
    computed: {
        footerMenuEntriesRight() {
            return this.$appHost.store.getter("navigation/getMenu", "FOOTER").filter(e => e.alignment == 1);
        },
    }
});
// #endregion
